import CarsContainer from './containers/CarsContainer';

export default CarsContainer;